import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const HireAtLowPrice = () => {
  return <CommingSoon />;
};

export default HireAtLowPrice;
